module.exports = __webpack_public_path__ + "media/images/landing/second/photo7-f10e7a9284220aea940448062922d666.jpg";